import React, { Component } from 'react';


class NotFound extends Component {
  render() {
    return (
      <div>
        This page doesn&apos;t exist!
      </div>
    );
  }
}


export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js